import React, { createContext } from "react";
import { GoogleAnalytics } from "nextjs-google-analytics";

import AuthWrapper from "@/components/AuthWrapper";
import store from "@/lib/store";
// import { scan } from "react-scan";
import "../public/style.css";
import "../public/datepicker.css";
import "../public/print.css";
import Head from "next/head";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { Provider } from "react-redux";
import AppWrapper from "@/components/utils/AppWrapper";

import { AppPropsWithLayout } from "../lib/types";

type ThemeContextProps = {
  activeTheme: Record<string, any> | undefined;
  setActiveTheme:
    | React.Dispatch<React.SetStateAction<Record<string, any>>>
    | undefined;
};

export const ThemeContext = createContext<ThemeContextProps>({
  activeTheme: undefined,
  setActiveTheme: undefined,
});

function App({
  Component,
  pageProps: { session, ...pageProps },
  router,
}: AppPropsWithLayout) {
  // useEffect(() => {
  //   // Make sure to run React Scan after hydration
  //   scan({
  //     enabled: true,
  //   });
  // }, []);
  return (
    <Provider store={store}>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1, width=device-width,height=device-height,maximum-scale=1"
        />
      </Head>
      <AuthWrapper router={router}>
        <AppWrapper Component={Component} pageProps={pageProps} />
        {process.env.NODE_ENV === "production" ? (
          <>
            <SpeedInsights />
            <Analytics />
            <GoogleAnalytics {...pageProps} />
          </>
        ) : null}
      </AuthWrapper>
    </Provider>
  );
}

export default App;
